import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-background/50 text-center text-foreground" aria-label="Offerta a tempo limitato" data-id="element-212" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-accent" aria-hidden="true" data-id="element-213" data-mp="36b8xbx313g98" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-214" data-mp="31i6byc8end44">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-accent" data-id="element-215" data-mp="31heeswz5t7bq">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-216" data-mp="3b9aqxby2yxyy" /> Il prezzo di lancio termina tra
        </p>
        <Countdown className="mt-5" data-id="element-217" data-mp="3p9bpulusbvbs" />
        <p className="mt-7 font-bold text-muted" data-id="element-218" data-mp="3p8a51pnyvugv">Dopo, il prezzo aumenta e non tornerà più così basso.</p>
      </div>
      <div className="h-1 w-full bg-accent" aria-hidden="true" data-id="element-219" data-mp="3l53zkk8oi7bg" />
    </section>;
}